const $inject = [
  "$scope",
  "$state",
  "$uibModalInstance",
  "HmrService",
  "hmr",
  "type",
  "refund_reasons",
];

class HmrRefundRequestModalController {
  constructor(
    $scope,
    $state,
    $uibModalInstance,
    HmrService,
    hmr,
    type,
    refund_reasons
  ) {
    this.$scope = $scope;
    this.$state = $state;
    this.$uibModalInstance = $uibModalInstance;
    this.hmrService = HmrService;
    this.hmr = hmr;
    this.type = type;

    $scope.reasons = refund_reasons;
    $scope.submitted = false;
    $scope.saving = false;

    $scope.refund_request = {
      refund_reason: null,
      has_contacted_patient: false,
      has_contacted_clinic: false,
      clinic_contact: "",
      additional_information: "",
      has_no_patient_data: false,
    };
  }

  submit_refund_request(form) {
    this.$scope.submitted = true;
    this.$scope.saving = true;

    if (form.$valid) {
      this.loading = true;
      this.$scope.errorMessage = null;

      let self = this;

      let handleSuccess = function (response) {
        if (!response.data.error) {
          self.loading = false;
          self.error = false;
          self.errorMessage = null;
          self.$uibModalInstance.close(self.hmr); // Further actions handled by listener in WorkflowController (check function "modal")
          if (self.type === "pharmacist") {
            self.$state.go("app.hmrworkflow");
          }
        }
        else {
          handleError(response);
        }
      };

      let handleError = function (response) {
        self.loading = false;
        //TODO error handling
        self.error = true;
        self.$scope.errorMessage = response.data.message? response.data.message: "An error occurred.";
        self.$scope.saving = false;
      };

      this.hmrService.refund_request(this.type, this.hmr.id, this.$scope.refund_request, handleSuccess, handleError);
    }
  }

  cancel() {
    this.$uibModalInstance.dismiss("cancel");
  }
}

HmrRefundRequestModalController.$inject = $inject;

export default HmrRefundRequestModalController;



/** WEBPACK FOOTER **
 ** D:/server/Apache24/htdocs/hmr/app/HMRX_App/scripts/src/features/referral/controllers/modals/refund-request.controller.js
 **/